export default function Clock_Numbers() {
  return (
    <div>
      <h1>Clock_Numbers Component</h1>
    </div>
  );
}
